__turbopack_context__.v({
  "Back": "SingleCareerListing-module-sass-module__T-a9la__Back",
  "Content": "SingleCareerListing-module-sass-module__T-a9la__Content",
  "Main": "SingleCareerListing-module-sass-module__T-a9la__Main",
  "SingleCareerListing": "SingleCareerListing-module-sass-module__T-a9la__SingleCareerListing",
  "Title": "SingleCareerListing-module-sass-module__T-a9la__Title",
});
